import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import TagManager from 'react-gtm-module';

export function initializeAnalytics(analytics: any) {
  if (analytics.googleAnalyticsActive) {
    ReactGA.initialize(analytics.googleAnalyticsId);
    ReactGA.pageview(window.location.pathname);
  }
  if (analytics.googleTagManagerActive) {
    let config = {
      gtmId: analytics.googleTagManagerId
    }
    TagManager.initialize(config);
    TagManager.dataLayer({
      dataLayer: {
        event: "PageView",
        path: window.location.pathname
      }
    });
  }
  if (analytics.facebookPixelActive) {
    const options = {
      autoConfig: true,
      debug: false,
    };
    ReactPixel.init(analytics.facebookPixelId, undefined, options);
    ReactPixel.pageView();
  }
}